import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            customerId: yup.string().required(__(`form.customerId.error`)),
            name: yup.string().required(__(`form.name.error`)),
            address: yup.string().required(__(`form.address.error`)),
            city: yup.string().required(__(`form.city.error`)),
            municipality: yup.number().required(__(`form.municipality.error`)).min(1, __(`form.municipality.error`)),
            department: yup.number().required(__(`form.department.error`)).min(1, __(`form.department.error`)),
            email: yup.string().email(__(`form.email.error`)).nullable(),
        })
    )
}

export default validators
